export default __webpack_public_path__ + "static/media/partnerImg2.9e7a3d34.webp";